// src/components/Register/Register.js
import { useState } from 'react';
import { auth } from '../../utils/config';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // Obtén la función de navegación

  const handleRegister = async () => {
    try {
      // Crear un nuevo usuario con correo electrónico y contraseña
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      console.log('Usuario registrado exitosamente', userCredential.user);
      navigate('/');

    } catch (error) {
      console.error('Error al registrar usuario:', error.code, error.message);
    }
  };

  return (
    <div>
      <h2>Registro de Usuario</h2>
      <label>Email:</label>
      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <label>Contraseña:</label>
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleRegister}>Registrar</button>
    </div>
  );
};

export default Register;
